<template>
  <div>
    <v-layout class="text-xs-right">
      <v-btn  @click="openDialog()" :color="ui.bkgdColor" icon>
        <v-icon :color="ui.btnColor"> source </v-icon>
      </v-btn>
      <v-dialog v-model="dialog" :max-width="ui.sizeWidthDialogLarge">
        <v-card color="wplgrey0">
          <v-card-title :class="ui.textTitle">
            {{defineIDGShortLastSix(selectedMaintActivityItem.basic.idi)}} Maint. Activity
            <v-spacer/>
            {{displayDocumentIDGTypeA(selectedMaintActivityItem.basic.tag, selectedMaintActivityItem.basic.idg)}}
          </v-card-title>
          <v-progress-linear :color="ui.textColor" height="1" value="100">
          </v-progress-linear>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-container>
              <v-layout row :class="ui.textSubheadingBold">
                <div class="ml-2">
                  Maintenance Activity
                </div>
                <v-spacer/>
                <v-chip :color="ui.chipColor" :class="ui.textSubheading">
                  <v-icon left :color="ui.btnColor">work_history</v-icon>
                  {{selectedMaintActivityItem.stats.nm5}}
                </v-chip>
              </v-layout>
              <v-layout row wrap class="mr-2">
                <v-flex xs12 sm8>
                  <v-text-field
                  v-model="selectedMaintActivityItem.basic.title"
                  hint="part name"
                  prepend-icon="title"
                  persistent-hint
                  readonly
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm4>
                  <v-text-field
                  v-model="selectedMaintActivityItem.char.type"
                  hint="type"
                  prepend-icon="grid_view"
                  persistent-hint
                  readonly
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="mr-2">
                <v-flex xs12 sm4>
                  <v-text-field
                  v-model="selectedMaintActivityItem.basic.id"
                  hint="part id"
                  prepend-icon="fingerprint"
                  persistent-hint
                  readonly
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm4>
                  <v-text-field
                  v-model="selectedMaintActivityItem.char.dis"
                  hint="discipline"
                  prepend-icon="engineering"
                  persistent-hint
                  readonly
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm4>
                  <v-text-field
                  v-model="selectedMaintActivityItem.char.owner"
                  hint="owner"
                  prepend-icon="person"
                  persistent-hint
                  readonly
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row class="mr-2">
                <v-flex xs12 sm6>
                  <v-text-field
                  v-model="selectedMaintActivityItem.char.driver"
                  prepend-icon="admin_panel_settings"
                  hint="driver"
                  persistent-hint
                  readonly
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field
                  v-model="selectedMaintActivityItem.char.comp"
                  prepend-icon="assured_workload"
                  hint="compliance"
                  persistent-hint
                  readonly
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row class="mr-2">
                <v-flex xs12 sm6>
                  <v-text-field
                  v-model="selectedMaintActivityItem.char.scope"
                  prepend-icon="check_box_outline_blank"
                  hint="scope"
                  persistent-hint
                  readonly
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field
                  v-model="selectedMaintActivityItem.char.fail"
                  prepend-icon="error_outline"
                  hint="failure modes"
                  persistent-hint
                  readonly
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row class="mr-2">
                <v-flex xs12 sm6>
                  <v-text-field
                  v-model="selectedMaintActivityItem.char.method"
                  hint="model"
                  prepend-icon="model_training"
                  persistent-hint
                  readonly
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field
                  v-model="selectedMaintActivityItem.char.model"
                  prepend-icon="adjust"
                  hint="method"
                  persistent-hint
                  readonly
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="mr-2">
                <v-flex xs12 sm3>
                  <v-text-field
                  v-model="selectedMaintActivityItem.char.freq"
                  prepend-icon="manage_history"
                  persistent-hint
                  hint="freq"
                  readonly
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm3>
                  <v-text-field
                  v-model="selectedMaintActivityItem.char.unit"
                  prepend-icon="event"
                  persistent-hint
                  hint="unit"
                  readonly
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field
                  v-model="selectedMaintActivityItem.char.cond"
                  prepend-icon="build_circle"
                  hint="condition"
                  persistent-hint
                  readonly
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="mr-2">
                <v-flex xs12 sm4>
                  <v-text-field
                  v-model="selectedMaintActivityItem.char.imp"
                  prepend-icon="group_add"
                  hint="impact"
                  persistent-hint
                  readonly
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm4>
                  <v-text-field
                  v-model="selectedMaintActivityItem.char.coste"
                  prepend-icon="paid"
                  hint="cost"
                  :suffix="selectedMaintActivityItem.char.costu"
                  persistent-hint
                  readonly
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm4>
                  <v-text-field
                  v-model="selectedMaintActivityItem.char.carbu"
                  prepend-icon="co2"
                  :suffix="selectedMaintActivityItem.char.carbu"
                  hint="carbon"
                  persistent-hint
                  readonly
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> short_text </v-icon>
                  </v-avatar>
                  Maintenance Activity Description
                </v-chip>
                <v-spacer/>
              </v-layout>
              <v-layout class="text-xs-left ml-4 mr-2 mt-2">
                <div :class="ui.textSubheading">
                  {{selectedMaintActivityItem.char.com}}
                </div>
              </v-layout>
            </v-container>
            <v-layout row>
              <v-btn @click="closeDialog()" :color="ui.btnColor" flat>
                <v-icon left> exit_to_app </v-icon>
                Close
              </v-btn>
              <v-spacer/>
            </v-layout>
          </v-form>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import dateFunctions from "@/data/functions/mixins/dateFunctions.js";
import numberFunctions from "@/data/functions/mixins/numberFunctions.js";
import financeFunctions from "@/data/functions/mixins/financeFunctions.js";
import displayFunctions from "@/data/functions/mixins/displayFunctions.js";
import master from "@/data/forms/mixins/master.js";
export default {
  // eslint-disable-next-line
  mixins: [
    master,
    dateFunctions,
    apptheme,
    numberFunctions,
    financeFunctions,
    displayFunctions
  ],
  computed: {
    ...mapGetters(["getMaintActivityList", "getCurrentPage"]),
    // selected task item
    selectedMaintActivityItem() {
      return this.maintActivity;
    }
  },
  props: {
    maintActivity: {
      type: Object
    }
  },
  data() {
    return {
      dialog: false,
      valid: false
    };
  },
  methods: {
    openDialog() {
      this.dialog = true;
    },
    closeDialog() {
      this.dialog = false;
    }
  }
};
</script>
